import { render, staticRenderFns } from "./UploadSelectionPage.vue?vue&type=template&id=5fdc758d&scoped=true&"
import script from "./UploadSelectionPage.vue?vue&type=script&lang=js&"
export * from "./UploadSelectionPage.vue?vue&type=script&lang=js&"
import style0 from "./UploadSelectionPage.vue?vue&type=style&index=0&id=5fdc758d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdc758d",
  null
  
)

export default component.exports